import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import AddIcon from '@mui/icons-material/Add'
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    LinearProgress,
} from '@mui/material'
import { studentApiSlice } from '../../../../features/student/studentSlice'
import { groupApiSlice } from '../../../../features/group/groupSlice'
import NoGroupStudentsTable from './NoGroupStudentsTable'

const AddGroupStudentDialog = () => {
    const { formatMessage } = useIntl()
    const { groupId } = useParams()
    const [openDialog, setOpenDialog] = useState(false)
    const [studentsInfo, setStudentsInfo] = useState([])
    const [page, setPage] = React.useState(1)
    const [rowsPerPage, setRowsPerPage] = React.useState(5)
    const {
        data: studentsDataResponse = null,
        isFetching: isFetchingStudents,
    } = groupApiSlice.useFetchAllGroupStudentsNoGroupQuery(
        {
            groupId: Number(groupId),
            params: `page=${page - 1}&size=${rowsPerPage}`,
        },
        { skip: !openDialog },
    )
    const [getStudentsInfoByIds, { isLoading: isLoadingStudentsInfo }] =
        studentApiSlice.useGetStudentsInfoByIdsMutation()
    const [addStudentToGroup, { isLoading: isAddingStudent }] =
        groupApiSlice.useAddStudentToGroupMutation()

    const getStudentsInfo = async () => {
        try {
            const result = await getStudentsInfoByIds(
                studentsDataResponse.data.map((student) => student.userId),
            ).unwrap()
            setStudentsInfo(result)
        } catch (error) {}
    }

    const handleAddStudentToGroup = async (courseUserEnrollId: number, courseSubjectId: number) => {
        try {
            await addStudentToGroup({
                courseUserEnrollId,
                studentGroupId: Number(groupId),
                courseSubjectId
            }).unwrap()
            toast.success(formatMessage({ id: 'savedSuccess' }))
        } catch (error) {}
    }

    const handleClickOpen = () => {
        setOpenDialog(true)
    }

    const handleCloseDialog = () => {
        setOpenDialog(false)
    }

    useEffect(() => {
        if (studentsDataResponse?.data?.length) {
            getStudentsInfo()
        }
    }, [studentsDataResponse?.data])

    return (
        <div>
            <Button
                onClick={handleClickOpen}
                variant="contained"
                endIcon={<AddIcon />}
            >
                {formatMessage({ id: 'addStudent' })}
            </Button>

            <Dialog
                maxWidth={'md'}
                fullWidth
                open={openDialog}
                onClose={handleCloseDialog}
            >
                <DialogTitle id="responsive-dialog-title">
                    {formatMessage({ id: 'addStudent' })}
                </DialogTitle>

                <DialogContent>
                    {isFetchingStudents || isAddingStudent ? (
                        <LinearProgress />
                    ) : (
                        studentsDataResponse && (
                            <NoGroupStudentsTable
                                studentsData={studentsDataResponse.data}
                                studentsInfo={studentsInfo}
                                isFetchingStudents={isFetchingStudents}
                                isLoadingStudentsInfo={isLoadingStudentsInfo}
                                isAddingStudent={isAddingStudent}
                                pageNumber={studentsDataResponse.pageNumber}
                                totalCount={studentsDataResponse.totalCount}
                                page={page}
                                rowsPerPage={rowsPerPage}
                                setPage={setPage}
                                setRowsPerPage={setRowsPerPage}
                                addStudentToGroup={handleAddStudentToGroup}
                            />
                        )
                    )}
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default AddGroupStudentDialog
